import React from "react";
import "./Loading.css";

export default function Loading() {
    return (
        <div className="loading-auth">
            <div className="loader-auth" />
        </div>
    );
}
